import React from 'react';
import { LoadingState, EmptyState } from '../../ui';
import { tabCtxShape } from './tabContext';

/**
 * Photos (P-UNIT-079): the listing photos in a grid; each opens the page's
 * photo viewer at its index. Today's loading and empty wording.
 */
export default function PhotosTabV2({ ctx }) {
    const { unit, detail, openLightbox } = ctx;
    const { images, imagesLoading } = detail;
    if (imagesLoading) return <LoadingState label="Loading photos..." />;
    if (!images.length) return <EmptyState message="No photos available for this unit." />;
    return (
        <div className="u2-card">
            <div className="u2-c-head">
                <h3>Photos</h3>
                <span className="u2-sub">
                    {images.length} photo{images.length !== 1 ? 's' : ''} from the listing · arrow keys move in the viewer
                </span>
            </div>
            <div className="u2-ph-grid">
                {images.map((url, idx) => (
                    <button
                        // eslint-disable-next-line react/no-array-index-key
                        key={idx}
                        type="button"
                        className="u2-ph"
                        onClick={() => openLightbox(idx)}
                        aria-label={`View photo ${idx + 1}`}
                    >
                        <img src={url} alt={`${unit.MAKE} ${unit.MODEL} — view ${idx + 1}`} loading="lazy" />
                    </button>
                ))}
            </div>
        </div>
    );
}

PhotosTabV2.propTypes = { ctx: tabCtxShape.isRequired };
